import { render } from "./TextDemo.vue?vue&type=template&id=67484cde&scoped=true"
const script = {}

import "./TextDemo.vue?vue&type=style&index=0&id=67484cde&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67484cde"]])

export default __exports__